import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { Calendar, MapPin, Star, ChevronRight, ChevronLeft } from 'lucide-react';
import tantric from '../assets/shutterstock_1093426625.jpg';
import mantant from '../assets/mantantra.jpg';
import preg from '../assets/preg_orig.jpg';
import ServiceCard from './ServiceCard';


function Content(props) {
    const user = props.userType;
    const city = props.city;
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);

    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        fetchServices();
    }, [props.userType]);

    const fetchServices = async () => {
        setLoading(true);
        try {
            // Fetch all services first
            const { data: servicesData, error: servicesError } = await supabase
                .from('services')
                .select(`
        *,
        options:service_options(*)
      `)
                .order('id');

            if (servicesError) throw servicesError;

            // Filter services in JavaScript
            const filteredServices = servicesData.filter(service =>
                service.user_types.includes(user) || service.user_types.includes('all')
            );

            // Process the data to add city-specific pricing
            const processedServices = filteredServices.map(service => ({
                ...service,
                options: service.options?.map(option => ({
                    ...option,
                    price: city === "Austin"
                        ? option.price_austin
                        : city === "SanAntonio"
                            ? option.price_san_antonio
                            : option.price_default
                }))
            }));

            setServices(processedServices);
        } catch (error) {
            console.error('Error fetching services:', error);
        } finally {
            setLoading(false);
        }
    };

    console.log(services);

    if (loading) {
        return <div className="text-center py-5">Loading services...</div>;
    }

    const pregTestimonials = [
        {
            text: "Was very skeptical that this would actually work. After plenty of questions with Jay and my doctor, the Perineal Massage did infact help with my dilation and delivery my second child compared to my first",
            author: "Hailey R."
        },
        {
            text: "OH MY GOD! I feel like I'm still walking on clouds and myappointment was two days ago! As a first-time mom, I didn't realize how much I needed this. Jay eased my worries, and was so gentle with me. I will definitely be back!",
            author: "Jenny U."
        },
        {
            text: "This was my first time trying a perineal massage, and I'm so glad I did. Not only did it help with my aches, but it was a complete mood booster! Jay knew exactly how to make mefeel comfortable, and I left feeling recharged. Am ust-try for any mom-to-be!",
            author: "Janelle M."
        },
    ];
    const testimonials = [
        {
            text: "You are the best when it comes to relieving my stress, allowing me to escape from the \"busy\" of my life and make me feel very cared for. I do not have that luxury regularly in my world right now...but you are amazing at fulfilling that for me. ☺️",
            author: "Angie"
        },
        {
            text: "Finally understand what people mean when they say they slept like a baby... Can't remember how long it's been since I slept this well. Appreciate you, Jay",
            author: "Anon."
        },
        {
            text: "Jay was amazing! I worked with him to set up a Swedish Massage/Yoni massage for my wife. I left the Yoni massage open to her to if she felt comfortable enough to do it but after meeting and talking to Jay in person for 5 minutes, she had no reservations. He couldn't have been more professional. I stayed in the room with my wife and he even asked me to join in (at my request) and taught me a few things. It's not the easiest service to find but we found our guy and can't wait to use him again. If you're on the fence, don't be, it's very much worth it.",
            author: "Scott H."
        },
        {
            text: "Jay was professional, caring, and most importantly respectful. The perfect environment for healing and relaxation.",
            author: "Amanda T."
        },
        {
            text: "The yoni massage helped me heal from past trauma. Forever grateful for this service.",
            author: "Lisa B."
        },
        {
            text: "Exceptional service from start to finish. The conversation during the consultation made me feel at ease immediately.",
            author: "Rachel S."
        },
        {
            text: "Jay was professional and his calm demeanor made me comfortable immediately. The massage was incredible and such a mind body connection. I will definitely be a regular customer.",
            author: "Kelly W."
        },
        {
            text: "I've just became a regular for Jay, for the last three weeks, I highly recommend his Deep Thigh Massage.",
            author: "Kim G."
        },
        {
            text: "I received my first Yoni Massage from Jay, and Imust say, it was mind blowing. He eased my hesitance, and skepticism before any session took place. He walked me through the session beforehand, and reiterated if I wanted/needed anything to communicate that with him. I highly recommend his services.",
            author: "Marisol G."
        }
    ];

    const nextSlide = () => {
        user === "pregnant" ?
        setCurrentSlide((prev) => (prev + 1) % pregTestimonials.length) :
        setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    };

    const prevSlide = () => {
        user === "pregnant" ? 
        setCurrentSlide((prev) => (prev - 1 + pregTestimonials.length) % pregTestimonials.length)
        : setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    };

    //get service duration and pricing for notification purposes

    return (
        <div className='container'>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                {/*///////////// Hero Section ///////////*/}
                <div className="text-center mb-4">
                    <h1 class="display-6 fw-bolder text-dark mb-3 pt-4">
                        Mobile Body Therapy
                    </h1>
                    <img src={props.userType === "pregnant" ? preg : props.userType === "him" ? mantant : tantric} className="img-fluid pb-2" width="750" style={{ borderRadius: "10px" }} />

                    <p class="lead text-muted mb-4 mx-auto">
                        Mobile Body Therapy brings customized sensual massage sessions to your location.
                    </p>
                    <a
                        href="#book"
                        class="btn btn-warning text-dark px-4 py-2 rounded-lg"
                    >
                        Book Your Session
                        <ChevronRight />
                    </a>
                </div>

                {/*/////////// Features ///////////*/}
                <div className="row mb-4">
                    <div class="col-sm-6 col-md-4 mb-4">
                        <div class="bg-white rounded shadow p-4 text-center transition-transform transform hover:scale-105">
                            <div class="w-16 h-16 bg-warning bg-opacity-25 rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4 p-3" style={{ width: "75px", borderRadius: "50%" }}>
                                <Calendar class="text-warning" size={48} />
                            </div>
                            <h3 class="h5 font-weight-bold mb-2">Easy Booking</h3>
                            <p class="text-muted">Schedule your appointment online with flexible availability</p>
                        </div>
                    </div>
                    <div class="col-sm-6 col-md-4 mb-4">
                        <div class="bg-white rounded shadow p-4 text-center transition-transform transform hover:scale-105">
                            <div class="w-8 h-16 bg-primary bg-opacity-25 d-flex align-items-center justify-content-center mx-auto mb-4 p-3" style={{ width: "75px", borderRadius: "50%" }}>
                                <MapPin class="text-primary" size={48} />
                            </div>
                            <h3 class="h5 font-weight-bold mb-2">Mobile Service</h3>
                            <p class="text-muted">We come to you at your desired location, or one can be provided.</p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-4 mb-4">
                        <div class="bg-white rounded shadow p-4 text-center transition-transform transform hover:scale-105">
                            <div class="w-16 h-16 bg-success bg-opacity-25 rounded-circle d-flex align-items-center justify-content-center mx-auto mb-4 p-3" style={{ width: "75px", borderRadius: "50%" }}>
                                <Star class="text-success" size={48} />
                            </div>
                            <h3 class="h5 font-weight-bold mb-2">Expert Therapists</h3>
                            {user === "pregnant" ? <p class="text-muted">Specialized in tantric, yoni, perineal and relaxation massage</p> : <p class="text-muted">Specialized in tantric, yoni, and relaxation massage</p>}
                        </div>
                    </div>
                </div>

                {/*/////////// How It Works ///////////*/}
                <div id="how-it-works" className="mb-4">
                    <h2 class="display-4 font-weight-bold text-dark mb-4 text-center">How It Works</h2>
                    <div class="row justify-content-center">
                        <div class="col-md-4 text-center mb-4">
                            <div class="bg-warning text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2" style={{ width: "64px", height: "64px", fontSize: "24px", fontWeight: "bold", boxShadow: "0 4px 8px rgba(0,0,0,0.2)" }}>
                                1
                            </div>
                            <h3 class="h5 font-weight-semibold mb-3">Free Consultation</h3>
                            <p class="text-muted">
                                Schedule a 15-minute Zoom/Facetime, Phone call, or text conversation to discuss your needs and preferences
                            </p>
                        </div>
                        <div class="col-md-4 text-center mb-4">
                            <div class="bg-warning text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2" style={{ width: "64px", height: "64px", fontSize: "24px", fontWeight: "bold", boxShadow: "0 4px 8px rgba(0,0,0,0.2)" }}>
                                2
                            </div>
                            <h3 class="h5 font-weight-semibold mb-3">Book Your Session</h3>
                            <p class="text-muted">
                                Choose your service, location, and preferred time that works best for you
                            </p>
                        </div>
                        <div class="col-md-4 text-center mb-4">
                            <div class="bg-warning text-white rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2" style={{ width: "64px", height: "64px", fontSize: "24px", fontWeight: "bold", boxShadow: "0 4px 8px rgba(0,0,0,0.2)" }}>
                                3
                            </div>
                            <h3 class="h5 font-weight-semibold mb-3">Enjoy & Relax</h3>
                            <p class="text-muted">
                                Experience your personalized massage session in the comfort of your space
                            </p>
                        </div>
                    </div>
                </div>

                {/*/////////// Book Now ///////////*/}
                <div id="book" className="mb-4">
                    <div className="">
                        <ServiceCard services={services} user={user}/>
                    </div>
                </div>

                {/*/////////// Testimonials ///////////*/}
                <div id="testimonials" className="mb-4">
                    <h2 className="display-4 font-weight-bold text-dark mb-4 text-center">Client Testimonials</h2>
                    <div className="container testaCont" style={{ maxWidth: "900px"}}>
                        <div className="bg-white rounded shadow-lg p-4">
                            {/* Carousel Content */}
                            <div style={{ minHeight: "200px" }} className="d-flex flex-column justify-content-center">
                                <p className="text-dark fs-5 fst-italic mb-4 text-center getSmall">
                                    "{user === "pregnant" ? pregTestimonials[currentSlide].text : testimonials[currentSlide].text}"
                                </p>
                                <p className="text-muted fw-semibold text-center">
                                    - {user === "pregnant" ? pregTestimonials[currentSlide].author : testimonials[currentSlide].author}
                                </p>
                                <div className="d-flex mb-3 justify-content-center">
                                    {[...Array(5)].map((_, i) => (
                                        <Star key={i} className="text-warning" fill="currentColor" size={24} />
                                    ))}
                                </div>
                            </div>

                            {/* Navigation Buttons and Indicators */}
                            <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
                                <button
                                    onClick={prevSlide}
                                    className="btn btn-warning text-white p-1 rounded-circle border-0 align-items-center justify-content-center d-flex"
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        transition: "all 0.3s ease",
                                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                                    }}
                                    aria-label="Previous testimonial"
                                >
                                    <ChevronLeft size={20} />
                                </button>

                                {/* Indicators */}
                                <div className="d-flex justify-content-center gap-2">
                                    {user === "pregnant" ? pregTestimonials.map((_, index) => (
                                        <button
                                            key={index}
                                            onClick={() => setCurrentSlide(index)}
                                            className="border-0 rounded-pill"
                                            style={{
                                                width: currentSlide === index ? "32px" : "8px",
                                                height: "8px",
                                                backgroundColor: currentSlide === index ? "#ffc107" : "#dee2e6",
                                                transition: "all 0.3s ease",
                                                cursor: "pointer"
                                            }}
                                            aria-label={`Go to testimonial ${index + 1}`}
                                        />
                                    )) :
                                    testimonials.map((_, index) => (
                                        <button
                                            key={index}
                                            onClick={() => setCurrentSlide(index)}
                                            className="border-0 rounded-pill"
                                            style={{
                                                width: currentSlide === index ? "32px" : "8px",
                                                height: "8px",
                                                backgroundColor: currentSlide === index ? "#ffc107" : "#dee2e6",
                                                transition: "all 0.3s ease",
                                                cursor: "pointer"
                                            }}
                                            aria-label={`Go to testimonial ${index + 1}`}
                                        />
                                    ))}
                                </div>

                                <button
                                    onClick={nextSlide}
                                    className="btn btn-warning text-white p-1 rounded-circle border-0 align-items-center justify-content-center d-flex"
                                    style={{
                                        width: "40px",
                                        height: "40px",
                                        transition: "all 0.3s ease",
                                        boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                                    }}
                                    aria-label="Next testimonial"
                                >
                                    <ChevronRight size={20} />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Content
